import ConfiguracoesModulosPage from "@/Pages/Administracao/ConfiguracoesModulosPage.vue";
import AparelhosFaciaisPage from "@/Pages/Administracao/AparelhosFaciaisPage.vue";
import MinhasNotificacoesPage from "@/Pages/Administracao/MinhasNotificacoesPage.vue";
import store from "@/store";
import authService from "@/Services/AuthService";

const ROLES_ADMIN = ["admin", "super-admin", "TI"];
const ROLES_APARELHOS = ["admin", "super-admin"];
const ROLES_NOTIFICACOES = ["admin", "super-admin", "TI", "lider"];

function exigirPerfis(roles) {
  return async (to, from, next) => {
    let user = store.getters["Auth/user"];
    if (!user && authService.isLoggedIn()) {
      try {
        await authService.syncUserWithStore();
      } catch (e) {
        // ignore
      }
      user = store.getters["Auth/user"];
    }
    if (!roles.includes(user?.roleName)) {
      return next({ name: "NaoAutorizado" });
    }
    return next();
  };
}

export default [
  {
    path: "/administracao/configuracoes",
    name: "administracao.configuracoes",
    component: ConfiguracoesModulosPage,
    beforeEnter: exigirPerfis(ROLES_ADMIN),
  },
  {
    path: "/administracao/aparelhos",
    name: "administracao.aparelhos",
    component: AparelhosFaciaisPage,
    beforeEnter: exigirPerfis(ROLES_APARELHOS),
  },
  {
    path: "/administracao/minhas-notificacoes",
    name: "administracao.minhasNotificacoes",
    component: MinhasNotificacoesPage,
    beforeEnter: exigirPerfis(ROLES_NOTIFICACOES),
  },
];
